var _rect, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _path3, _path4, _path5, _path6, _path7, _path8, _rect7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAliasImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 223,
    height: 165,
    viewBox: "0 0 223 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 7.63672,
    y: 7.58984,
    width: 215.364,
    height: 156.818,
    rx: 8.36364,
    fill: "#C2CED4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 215.364,
    height: 156.818,
    rx: 8.36364,
    fill: "#5191FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.18188,
    y: 4.18359,
    width: 207,
    height: 148.455,
    rx: 8.36364,
    fill: "#95BEFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.6819,
    y: 15.6836,
    width: 184,
    height: 125.455,
    rx: 8.36364,
    fill: "#EFF5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.064 74.2178C72.6303 74.2178 83.628 63.2201 83.628 49.6538C83.628 36.0875 72.6303 25.0898 59.064 25.0898C45.4977 25.0898 34.5 36.0875 34.5 49.6538C34.5 63.2201 45.4977 74.2178 59.064 74.2178ZM59.064 61.369C65.5327 61.369 70.7791 56.1239 70.7791 49.6538C70.7791 43.1837 65.5327 37.9387 59.064 37.9387C52.5953 37.9387 47.3489 43.1837 47.3489 49.6538C47.3489 56.1239 52.5953 61.369 59.064 61.369Z",
    fill: "#C6DCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6262 49.6538C83.6262 36.0875 72.6285 25.0898 59.0622 25.0898C55.708 25.0898 52.5107 25.7622 49.5979 26.9794L54.9052 38.6977C56.1971 38.2072 57.5983 37.9387 59.0622 37.9387C65.5323 37.9387 70.7774 43.1838 70.7774 49.6538H83.6262Z",
    fill: "#95BEFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.5596,
    y: 36.4336,
    width: 85.7273,
    height: 10.4545,
    rx: 5.22727,
    fill: "#95BEFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0454,
    y: 53.3164,
    width: 69,
    height: 10.4545,
    rx: 5.22727,
    fill: "#C6DCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1365 126.5L49.1365 101.409C49.1365 98.5221 51.4768 96.1818 54.3637 96.1818C57.2507 96.1818 59.591 98.5221 59.591 101.409L59.591 126.5L49.1365 126.5Z",
    fill: "#C6DCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0454 126.5L70.0454 92C70.0454 89.1131 72.3857 86.7727 75.2727 86.7727C78.1596 86.7727 80.5 89.1131 80.5 92L80.5 126.5L70.0454 126.5Z",
    fill: "#95BEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9546 126.5L90.9546 105.591C90.9546 102.704 93.2949 100.364 96.1819 100.364C99.0688 100.364 101.409 102.704 101.409 105.591L101.409 126.5L90.9546 126.5Z",
    fill: "#C6DCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.864 126.5L111.864 96.1818C111.864 93.2949 114.204 90.9545 117.091 90.9545C119.978 90.9545 122.318 93.2949 122.318 96.1818L122.318 126.5L111.864 126.5Z",
    fill: "#95BEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.773 126.5L132.773 101.409C132.773 98.5221 135.113 96.1818 138 96.1818C140.887 96.1818 143.227 98.5221 143.227 101.409L143.227 126.5L132.773 126.5Z",
    fill: "#C6DCFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M153.682 126.5L153.682 88.8636C153.682 85.9767 156.022 83.6364 158.909 83.6364C161.796 83.6364 164.136 85.9767 164.136 88.8636L164.136 126.5L153.682 126.5Z",
    fill: "#95BEFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5,
    y: 125.453,
    width: 144.273,
    height: 4.18182,
    rx: 2.09091,
    fill: "#95BEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 152.638L81.2727 4.18359H104.273L66.0455 152.638H42Z",
    fill: "#EFF5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2273 152.638L108.455 4.18359H119.432L80.6818 152.638H70.2273Z",
    fill: "#EFF5FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAliasImage);
export default __webpack_public_path__ + "static/media/AliasImage.ee8c733d75fe8e3a89f373ef8a4b2bd1.svg";
export { ForwardRef as ReactComponent };